'use strict';
import {getId, getLink} from '../../core-utilities/domain/ReduxUtils';


export const CLASS_NAME = 'PersonDomain';
export const COLLECTION = 'personnel';
export const PERSONNEL_COLLECTION = 'personnel';

export function PersonDomainProvider() {
  return {
    $get: [
      'AbstractDomainClass',
      'AvatarMixin',
      '$filter',
      'fetchUtils',
      'restUtils',
      function (
        AbstractDomainClass,
        AvatarMixin,
        $filter,
        fetchUtils,
        restUtils,
      ) {
        //console.log('Created  PersonDomain');
        const abbreviate = $filter('abbreviate');

        function PersonDomain(data) {
          AbstractDomainClass.call(this, PersonDomain, data);
        }

        AbstractDomainClass.__inheritFrom(PersonDomain, CLASS_NAME, COLLECTION);

        PersonDomain.$constraints.addConstraints({
          name: {type: 'string', nullable: true}, //TODO: need custom validator that requires a name if this is not an alias
          firstName: {type: 'string', nullable: true},
          lastName: {type: 'string', nullable: true},
          role: {type: 'string', nullable: true},

          phone: {type: 'string', nullable: true},
          email: {type: 'string', nullable: true},

          organization: {type: 'Domain', domainClass: 'OrganizationDomain', nullable: true}, // link for the org specific contact data

          aliasFor: {type: 'Domain', domainClass: 'PersonDomain', nullable: true}, // TODO: implement contact aliasing system
          lastOnline: {type: 'Date', nullable: true, readOnly: true}, /* Last time user notified as active */
          lastSeen: {type: 'Date', nullable: true, readOnly: true}, /* Last time user notified server */

          // TODO: add more details

          user: {type: 'DomainLink', domainClass: 'UserDomain', nullable: true},
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'},

          teams: {type: 'DomainCollection', domainClass: 'TeamDomain', links: 'members'},
          aliases: {type: 'DomainCollection', domainClass: 'PersonDomain', link: 'aliasFor'} // alias relation is the org id
        });

        AvatarMixin(PersonDomain);

        // more methods go here;

        PersonDomain.prototype.getAvatarInitials = getAvatarInitials;
        PersonDomain.prototype.getAvatarIndex = getAvatarIndex;

        PersonDomain.prototype.create = restUtils.createProto(PersonDomain, {
          getBody: data => ({
            name: data.name,
            firstName: data.firstName,
            lastName: data.lastName,
            role: data.role,
            phone: data.phone,
            email: data.email,

            orgId: getLink(data, 'organization').id,
          }),
        });

        PersonDomain.prototype.update = restUtils.updateProto(PersonDomain);

        PersonDomain.isUser = function (instance) {
          if (!instance) {
            return false;
          } else {
            return !!getLink(instance, 'aliasFor').id || !!getLink(instance, 'user').id;
          }
        };

        /**
         * Assumes this is a user if it is an alias. This should be a valid assumption
         * @returns {boolean}
         */
        PersonDomain.prototype.isUser = function isUser() {
          return !!getLink(this, 'aliasFor').id || !!getLink(this, 'user').id;
        };

        PersonDomain.prototype.getCasualName = function getCasualName() {
          return this.firstName || this.name;
        };

        // Delegation methods for handling aliasing

        PersonDomain.prototype.getDelegatePerson = function getDelegatePerson() {
          if (getLink(this, 'aliasFor').id) {
            //console.log('PersonDomain.prototype.getDelegatePerson', this)
            //console.log('  -  ', this.aliasFor)
            return this.aliasFor;
          }
          return this;
        };

        PersonDomain.prototype.getEmail = function getEmail() {
          if (this.email) return this.email;
          else if (this.aliasFor && this.aliasFor.email) return this.aliasFor.email;
        };

        // TODO: move to server API. Other users will not have access to person.aliases
        PersonDomain.getOrganizationProfile = function getOrganizationProfile(personId, orgId) {
          return PersonDomain.$get(personId).then(function (person) {
            if (getLink(person, 'organization').id === orgId)
              return person;
            return PersonDomain.$getAllAliasesRelations(personId).then(function (aliases) {
              if (!aliases) return null;

              for (var aliasId in aliases) {
                if (aliases.hasOwnProperty(aliasId)) {
                  if (aliases[aliasId] === orgId) {
                    return PersonDomain.$get(aliasId);
                  }
                }
              }

              return null;
            });
          });
        };

        PersonDomain.prototype.getOrganizationProfile = function getOrganizationProfile(orgId) {
          if (getLink(this, 'organization').id)
            return Promise.resolve(getLink(this, 'organization').id);
          return PersonDomain.$getAllAliasesRelations(getId(this)).then(function (aliases) {
            //console.log('$getAllAliasesRelations:aliases', aliases);
            if (!aliases) return null;

            for (var aliasId in aliases) {
              if (aliases.hasOwnProperty(aliasId)) {
                var alias = aliases[aliasId];
                if (alias.organization && (alias.organization.id === orgId)) {
                  return PersonDomain.$get(aliasId);
                }
              }
            }

            return null;
          });
        };

        PersonDomain.prototype.toString = function toString() {
          return this.aliasFor ? this.aliasFor.name : this.name;
        };

        function getAvatarInitials() {
          return abbreviate(this.aliasFor ? this.aliasFor.name : this.name);
        }

        function getAvatarIndex() {
          return this.aliasFor ? this.aliasFor.avc : this.avc;
        }

        return PersonDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/personnel/domain/PersonDomain.js